import React, { useState, useEffect } from 'react';
import { Box, Text, Layer, TextInput, Button } from 'grommet';


import AlertDetailedView from '../alert/AlertDetailedView'

import { gql, useQuery } from '@apollo/client';

const SEARCH_NODE = gql`
query ($node: String!) {
    node(where: {name: {_ilike: $node}}, limit: 10) {
        name
        ip
        environment {
          name
        }
        serviceGroup_nodes {
          serviceGroup {
            group
          }
        }
        service_nodes {
          status
          instance
          service {
            id
            name
          }
        }
      }
}
`

const SEARCH_IP = gql`
query ($ipaddress: String!) {
    node(where: {ip: {_ilike: $ipaddress}}, limit: 10) {
        name
        ip
        environment {
          name
        }
        serviceGroup_nodes {
          serviceGroup {
            group
          }
        }
        service_nodes {
          status
          instance
          service {
            id
            name
          }
        }
      }
}
`

const SEARCH_INSTANCE = gql`
query ($instance: String!) {
    node(limit: 10, where: {service_nodes: {instance: {_eq: $instance}}}) {
        name
        ip
        environment {
          name
        }
        serviceGroup_nodes {
          serviceGroup {
            group
          }
        }
        service_nodes {
          status
          instance
          service {
            id
            name
          }
        }
      }
}
`

const SearchResults = ({ resultKey }) => {

    const [serviceGroupSelected, setServiceGroupSelected] = useState("")
    const [serviceInstanceSelected, setServiceInstanceSelected] = useState("")
    const [nodeSelected, setNodeSelected] = useState("")
    const [nodeTypeSelected, setNodeTypeSelected] = useState("")

    let background = ''
    let color = ''
    let status = ''

    if (!resultKey.service_nodes || resultKey.service_nodes.length === 0) {
        status = 'UNKNOWN'
    } else {
        status = resultKey.service_nodes[0].status
    }

    if (status === 'up') {
        background = 'light-2'
        color = 'ttok'
    } else if (status === 'down') {
        background = 'ttdown'
        color = 'white'
    } else if (status === 'partial') {
        background = 'ttpartial'
        color = "dark-3"
    } else {
        background = 'dark-5'
        color = "light-3"
    }

    const handleClickService = (serviceName, instance) => {
        //setServiceNameSelected("")

        setNodeSelected("")
        setNodeTypeSelected("")
        setServiceGroupSelected("")
        //setServiceNameSelected(serviceName)
        setServiceInstanceSelected(instance)
    }

    const handleClickNode = (serviceGroup, nodeName, nodeType) => {
        setNodeSelected("")

        //setServiceNameSelected("")
        setServiceInstanceSelected("")
        setServiceGroupSelected(serviceGroup)
        setNodeSelected(nodeName)
        setNodeTypeSelected(nodeType)
    }

    return (

        <>

            <Box key={resultKey.name} background={background} padding="xsmall">
                <Box direction="row" margin='xsmall' padding='xsmall'
                >

                    <Button
                        onClick={() => { resultKey.serviceGroup_nodes.length > 0 && handleClickNode(resultKey.serviceGroup_nodes[0].serviceGroup.group, resultKey.name, 'chef') }}
                        plain>
                            <Text color={color} size="xsmall" direction="row" fill="horizontal"
                                margin='xsmall'>
                                <Text size="xsmall" weight="bold">
                                    {resultKey.name}
                                </Text>
                                <Text size="xsmall" margin={{ left: "10px", right: "10px" }}>
                                    {resultKey.ip}
                                </Text>
                                {resultKey.environment.name}
                            </Text>
                    </Button>
                </Box>
                <Box direction="row" margin='small' padding='small' gap='small'>
                    {resultKey.service_nodes.length > 0 && resultKey.service_nodes.map(
                        serviceKey => (
                            <Button
                                plain
                                key={serviceKey.instance+serviceKey.service.name}
                                hoverIndicator={{ color: "light-1", opacity: "strong" }}
                                label={
                                    <Box
                                        background="light-4"
                                        pad="3px"
                                    >
                                        <Text margin={{ right: "5px" }} direction="row"
                                            key={serviceKey.service.instance}
                                            size="xsmall"
                                            textAlign="center"
                                            color={serviceKey.status === "up" ? "ttok" : (serviceKey.status === "down" ? "ttdown" : "ttpartial")}
                                            onClick={() => {
                                                handleClickService(serviceKey.service.name, serviceKey.instance)
                                            }}
                                        >
                                            {serviceKey.service.name}
                                        </Text>
                                    </Box>
                                }
                            />

                        )
                    )
                    }
                </Box>
            </Box>

            {(serviceInstanceSelected.length > 0 || nodeSelected.length > 0) &&
                <AlertDetailedView
                    serviceInstanceSelected={serviceInstanceSelected}
                    nodeSelected={nodeSelected}
                    nodeTypeSelected={nodeTypeSelected}
                    serviceGroupSelected={serviceGroupSelected}
                />
            }

        </>

    )
}

const SearchForm = () => {

    const [showSearch, setShowSearch] = useState(true)
    const [searchText, setSearchText] = useState('')
    const [result, setResult] = useState([])

    const result_ip = useQuery(
        SEARCH_IP,
        { variables: { ipaddress: searchText + '%' } }
    )

    const result_node = useQuery(
        SEARCH_NODE,
        { variables: { node: searchText + '%' } }
    )

    const result_instance = useQuery(
        SEARCH_INSTANCE,
        { variables: { instance: searchText } }
    )

    useEffect(() => {
        if(!result_node.loading && !result_ip.loading && !result_instance.loading &&
            result_node.data && result_ip.data && result_instance.data && searchText.length > 0
        ){
            if (isNaN(searchText.slice(0, 1))) {
                setResult(result_node.data)
            } else if (searchText.length > 15) {
                setResult(result_instance.data)
            } else {
                setResult(result_ip.data)
            }
        }
    } , [result_ip.loading, result_ip.data, result_node.loading, result_node.data, result_instance.loading, result_instance.data, searchText])

    return (
        <>
            {showSearch &&
                <Layer
                    position="top-right"
                    plain
                    margin={{top: "50px", right: "15px"}}
                    onEsc={() => {
                        setShowSearch(false)
                        setSearchText("")
                    }}
                    onClickOutside={() => {
                        setShowSearch(false)
                        setSearchText("")
                    }}
                >
                    <Box pad="medium" gap="small" width="medium" background="white" elevation="medium" >
                        <Text size='large'>Search</Text>
                        <TextInput
                            id="search"
                            placeholder="Node Name or IP or Instance ID"
                            value={searchText}
                            autoFocus
                            onChange={event => {
                                setSearchText(event.target.value)
                            }}
                        />
                        {searchText && searchText.length <= 2 &&
                            <Text size="small">{"Search Text Must be >=3 Chars"}</Text>
                        }
                        {searchText && searchText.length >= 3 && result && result.node && result.node.length === 10 &&
                            <Text size="small">{"Only Showing First 10 Results"}</Text>
                        }
                        {searchText && searchText.length >= 3 && result && result.node && (result.node).map(resultKey => (
                            <SearchResults resultKey={resultKey} key={resultKey.name} />
                        ))
                        }

                    </Box>
                </Layer>
            }
        </>

    )

}

export default SearchForm
